module.exports = __webpack_public_path__ + "img/timesheet.78d50025.svg";